import { UserApi } from 'api/UserApi';
import { authClient } from 'container/authClient';
import { userMapper } from 'container/userMapper';

export const userApi = new UserApi(authClient, userMapper);
